import { ApiError, ShapeError } from '@/api';
import type { Strings } from '@/str';

export function errorText(error: unknown, t: Strings): string {
  if (error instanceof ShapeError) return t.errGeneric;
  if (!(error instanceof ApiError)) return t.errNetwork;
  if (error.status === 404) return t.errNotFound;
  if (error.status >= 500) return t.errServer;
  return t.errGeneric;
}
